import { render, staticRenderFns } from "./stock_registration_management.vue?vue&type=template&id=a857f586&scoped=true&"
import script from "./stock_registration_management.vue?vue&type=script&lang=js&"
export * from "./stock_registration_management.vue?vue&type=script&lang=js&"
import style0 from "./stock_registration_management.vue?vue&type=style&index=0&id=a857f586&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a857f586",
  null
  
)

export default component.exports